<div id="start-page">
    <div class="box messages">
        <div class="box-header">Messages</div>
        <div class="box-content">
            <div class="message important">Welcome back to NonoJs!</div>
            <div id="msg-not-logged-in">
                <div class="message">You are not logged in. Savestates will be stored locally and lost if you clear your browser data.</div>
                <div class="message"><a id="button-login" href="#">Log in now.</a></div>
            </div>
            <div id="msg-logged-in">
                <div class="message">You are logged in as <span class="username">admin</span></div>
            </div>
        </div>
    </div>
    <div id="continue-root">
        <div class="box continue">
            <span class="box-header">Continue Playing</span>
            <div class="box-content">
                <div class="inner">
                    <div class="container">
                        <!-- Filled by Javascript -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="box notd">
        <span class="box-header">Nonograms of the Day</span>
        <div class="box-content">
            <!-- Filled by Javascript -->
        </div>
    </div>
    <div class="box other">
        <span class="box-header">Or...</span>
        <div class="box-content">
            <ul>
                <li><a id="button-random" href="#">...Play a random Nonogram.</a></li>
                <li><a id="button-catalog" href="#">...See full catalog of nonograms.</a></li>
                <li><a id="button-settings" href="#">...Change settings.</a></li>
            </ul>
        </div>
    </div>
</div>